module.exports = __webpack_public_path__ + "media/images/awards-5-e4d0f69a7787e3c59af7b47c8eb7a0ae.jpg";